/**
 * Admin 路由守卫
 * 未登录时重定向到 /admin/login
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import adminAuthService from '../../services/adminAuthService';

function RequireAdminAuth({ children }) {
  const location = useLocation();
  if (!adminAuthService.isLoggedIn()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}

export default RequireAdminAuth;
